import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import type { Orientation } from "../hooks/useBannerLogic";

const PREFIX = "BannerPreview";

const classes = {
  croppedState: `${PREFIX}-croppedState`,
  croppedStatePortrait: `${PREFIX}-croppedStatePortrait`,
  progress: `${PREFIX}-progress`,
  portraitBadge: `${PREFIX}-portraitBadge`,
};

const Root = styled("div")(() => ({
  [`& .${classes.croppedState}`]: {
    position: "absolute",
    textAlign: "center",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },

  [`& .${classes.croppedStatePortrait}`]: {
    position: "absolute",
    textAlign: "center",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },

  [`& .${classes.progress}`]: {
    color: "white",
  },

  [`& .${classes.portraitBadge}`]: {
    position: "absolute",
    top: 8,
    left: 8,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    color: "white",
    padding: "4px 8px",
    borderRadius: 4,
    fontSize: "12px",
    fontWeight: 500,
    zIndex: 1,
  },
}));

interface BannerPreviewProps {
  orientation: Orientation;
  imageUrl: string;
  croppedImageUrl?: string | null;
  isLoading?: boolean;
}

export function BannerPreview({
  orientation,
  imageUrl,
  croppedImageUrl,
  isLoading = false,
}: BannerPreviewProps) {
  const url = croppedImageUrl || imageUrl;
  return (
    <Root>
      <div
        className={
          orientation === "vertical"
            ? classes.croppedStatePortrait
            : classes.croppedState
        }
        style={{
          backgroundImage: url ? `url('${url}')` : undefined,
        }}
      >
        {orientation === "vertical" && (
          <div className={classes.portraitBadge}>2:3</div>
        )}
        {orientation === "horizontal" && (
          <div className={classes.portraitBadge}>16:9</div>
        )}
        {isLoading && <CircularProgress className={classes.progress} />}
      </div>
    </Root>
  );
}
